const $tabs = $('.about-tabs_tabs__tab');
const $contents = $('.about-tabs_content__details');
const $accordions = $('.about-tabs_accordion');

function activateTab(index) {
  $tabs.removeClass('active');
  $contents.hide();

  $tabs.eq(index).addClass('active');
  $contents.eq(index).show();
}

$tabs.on('click', function() {
  const index = $(this).index();
  activateTab(index);
});

activateTab(0);

// Accordion behavior for mobile - close other details when one opens
$accordions.on('toggle', function() {
  if (this.open) {
    $accordions.not(this).prop('open', false);
  }
});
